// extracted by mini-css-extract-plugin
export default {"fullPage":"uwXff1","divider":"Pg5uWn","studioEditor":"eXPDyL"};